var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("attendanceRecord.view"),
        visible: _vm.verifyPhotoDia,
        width: "30%"
      },
      on: {
        "update:visible": function($event) {
          _vm.verifyPhotoDia = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticStyle: { "text-align": "center" } },
        [
          _c("el-image", { attrs: { src: _vm.verifyPhoto } }, [
            _c(
              "div",
              {
                staticClass: "image-slot",
                attrs: { slot: "placeholder" },
                slot: "placeholder"
              },
              [
                _vm._v("\n        " + _vm._s(_vm.$t("common.loading"))),
                _c("span", { staticClass: "dot" }, [_vm._v("...")])
              ]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  _vm.verifyPhotoDia = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.yes")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4460f887", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4460f887","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/comComponent/verifyPhoto.vue
// module id = null
// module chunks = 